import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiCopy, FiCheck, FiShare2, FiMessageCircle, FiTwitter, FiSend } from 'react-icons/fi';
import { Button } from './ui/Button';

export const InviteSystem = ({ shareUrl, creatorName }) => {
  const [copied, setCopied] = useState(false);

  const shareText = `Hey! How well do you actually know me? Take my "Do You Know Me?" challenge and let's see your score! 🎮🔥\n\nTake the quiz here: ${shareUrl}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const shareVia = (platform) => {
    let url = '';
    switch (platform) {
      case 'whatsapp':
        url = `https://wa.me/?text=${encodeURIComponent(shareText)}`;
        break;
      case 'twitter':
        url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`;
        break;
      case 'telegram':
        url = `https://t.me/share/url?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareText)}`;
        break;
      default:
        if (navigator.share) {
          navigator.share({
            title: 'Do You Know Me?',
            text: shareText,
            url: shareUrl,
          });
          return;
        }
    }
    if (url) window.open(url, '_blank');
  };

  return (
    <div className="space-y-6">
      <div className="bg-white/5 rounded-3xl p-6 border border-white/10 shadow-xl overflow-hidden relative">
        <div className="absolute top-0 right-0 p-4 opacity-10">
          <SafeIcon icon={FiShare2} className="text-6xl" />
        </div>
        
        <h3 className="text-lg font-bold mb-4 flex items-center gap-2 text-white relative z-10">
          <span className="p-2 bg-[#0094f7]/20 rounded-lg">
            <SafeIcon icon={FiShare2} className="text-[#0094f7]" />
          </span>
          Invite Your Friends
        </h3>

        <div className="space-y-4 relative z-10">
          <div className="flex gap-2">
            <div className="flex-1 bg-black/40 border border-white/10 rounded-xl px-4 py-3 text-xs text-slate-400 truncate flex items-center font-mono">
              {shareUrl}
            </div>
            <Button onClick={handleCopy} className="px-4 py-3 min-w-[56px] h-full shrink-0">
              {copied ? <SafeIcon icon={FiCheck} className="text-[#d2ff02]" /> : <SafeIcon icon={FiCopy} />}
            </Button>
          </div>

          <div className="grid grid-cols-4 gap-3">
            <button 
              onClick={() => shareVia('whatsapp')}
              className="flex flex-col items-center gap-2 p-3 bg-green-500/10 hover:bg-green-500/20 rounded-2xl border border-green-500/20 transition-all group"
            >
              <SafeIcon icon={FiMessageCircle} className="text-green-500 text-xl group-hover:scale-110 transition-transform" />
              <span className="text-[10px] font-bold text-slate-400 uppercase">WA</span>
            </button>
            <button 
              onClick={() => shareVia('twitter')}
              className="flex flex-col items-center gap-2 p-3 bg-sky-500/10 hover:bg-sky-500/20 rounded-2xl border border-sky-500/20 transition-all group"
            >
              <SafeIcon icon={FiTwitter} className="text-sky-500 text-xl group-hover:scale-110 transition-transform" />
              <span className="text-[10px] font-bold text-slate-400 uppercase">X</span>
            </button>
            <button 
              onClick={() => shareVia('telegram')}
              className="flex flex-col items-center gap-2 p-3 bg-blue-500/10 hover:bg-blue-500/20 rounded-2xl border border-blue-500/20 transition-all group"
            >
              <SafeIcon icon={FiSend} className="text-blue-500 text-xl group-hover:scale-110 transition-transform" />
              <span className="text-[10px] font-bold text-slate-400 uppercase">TG</span>
            </button>
            <button 
              onClick={() => shareVia('native')}
              className="flex flex-col items-center gap-2 p-3 bg-white/5 hover:bg-white/10 rounded-2xl border border-white/10 transition-all group"
            >
              <SafeIcon icon={FiShare2} className="text-slate-300 text-xl group-hover:scale-110 transition-transform" />
              <span className="text-[10px] font-bold text-slate-400 uppercase">More</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};